__turbopack_context__.v({
  "container": "styles-module-scss-module__drblPq__container",
  "link": "styles-module-scss-module__drblPq__link",
  "tagContainer": "styles-module-scss-module__drblPq__tagContainer",
  "title": "styles-module-scss-module__drblPq__title",
});
